import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useLazyOwnerPropertiesListQuery,
  useLazyReceptionistMasterQuery,
  useLazyReceptionistViewQuery,
  useReceptionistCreateMutation,
  useReceptionistEditMutation,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const Receptionist = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const types = location?.state?.type;
  const [btn, setBtn] = useState(false);

  const [createList, setCreateList] = useState([]);
  const [property, setproperty] = useState("");
  const [propertyErr, setpropertyErr] = useState(false);
  const [ownerProperties, setOwnerProperties] = useState({});
  const [name, setname] = useState("");
  const [nameErr, setnameErr] = useState(false);
  const [email, setemail] = useState("");
  const [emailErr, setemailErr] = useState(false);
  const [mobile, setmobile] = useState("");
  const [mobileErr, setmobileErr] = useState(false);

  // RTK QUERY
  const [receptionistMasterApi] = useLazyReceptionistMasterQuery();
  const [receptionistCreateApi] = useReceptionistCreateMutation();
  const [receptionistEditApi] = useReceptionistEditMutation();
  const [ownerPropertiesListApi] = useLazyOwnerPropertiesListQuery();
  const [receptionistViewApi] = useLazyReceptionistViewQuery();

  const getReceptionistMaster = () => {
    receptionistMasterApi()
      .unwrap()
      .then((res) => {
        setCreateList(res?.properties);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getOwnerPropertiesList = (id) => {
    ownerPropertiesListApi(id)
      .unwrap()
      .then((res) => {
        setproperty(id);
        setOwnerProperties(res?.owner);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const receptionistView = () => {
    receptionistViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        if (res?.property?.id) {
          getOwnerPropertiesList(res?.property?.id);
        }

        if (res?.receptionist?.name) {
          setname(res?.receptionist?.name);
        }

        if (res?.receptionist?.email) {
          setname(res?.receptionist?.email);
        }

        if (res?.receptionist?.email) {
          setemail(res?.receptionist?.email);
        }

        if (res?.receptionist?.mobile) {
          setmobile(res?.receptionist?.mobile);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getReceptionistMaster();

    if (location?.state?.data?.id) {
      receptionistView();
    }
  }, []);

  const submitHandler = () => {
    if (
      property?.length == 0 ||
      name?.length == 0 ||
      mobile?.length == 0 ||
      email?.length == 0
    ) {
      setpropertyErr(true);
      setnameErr(true);
      setmobileErr(true);
      setemailErr(true);
    } else {
      const formdata = new FormData();
      formdata.append("name", name);
      formdata.append("email", email);
      formdata.append("mobile", mobile);
      formdata.append("owner_id", ownerProperties.owner_id);
      formdata.append("property_id", ownerProperties?.id);

      if (location?.state?.data?.id) {
        formdata.append("_method", "PUT");
        dispatch(saveLoader(true));
        setBtn(true);
        receptionistEditApi({
          id: location?.state?.data?.id,
          payload: formdata,
        })
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      } else {
        dispatch(saveLoader(true));
        setBtn(true);
        receptionistCreateApi(formdata)
          .unwrap()
          .then((res) => {
            dispatch(saveLoader(false));
            setBtn(false);
            if (res?.status == "success") {
              Swal.fire({
                text: res?.message,
                icon: "success",
              });
              navigate(-1);
            }
          })
          .catch((err) => {
            setBtn(false);
            dispatch(saveLoader(false));
            console.log("err", err);
          });
      }
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader
        type={types == "edit" ? "edit-receptionist" : "add-receptionist"}
      />
      <div className="p-3">
        <div className="mt-4 block block-rounded ">
          <div className="block-content">
            <Row>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Property Name
                  </label>
                  <select
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => getOwnerPropertiesList(e.target.value)}
                    value={property}
                  >
                    <option value={""} disabled>
                      Select Property Name
                    </option>
                    {createList?.map((item, ind) => {
                      return (
                        <option value={item?.id} key={ind}>
                          {`${item?.property_id} - ${item?.name}`}
                        </option>
                      );
                    })}
                  </select>
                </div>
                {property?.length == 0 && propertyErr && (
                  <p className="err">Select Property Name</p>
                )}
              </div>
              {ownerProperties?.owner?.name && (
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                      Property Owner
                    </label>
                    <input
                      className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                      value={ownerProperties?.owner?.name}
                      readOnly
                    />
                  </div>
                </div>
              )}
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Receptionist Name
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setname(e.target.value)}
                    value={name}
                  />
                </div>
                {name?.length == 0 && nameErr && (
                  <p className="err">Enter Name</p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    E-mail
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                  />
                </div>
                {email?.length == 0 && emailErr && (
                  <p className="err">Enter E-mail</p>
                )}
              </div>
              <div className="col-md-6 mb-3">
                <div className="form-group">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                    Mobile Number
                  </label>
                  <input
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                    onChange={(e) => setmobile(e.target.value)}
                    value={mobile}
                    type={"number"}
                    onInput={(e) => {
                      if (e.target.value.length > e.target.maxLength)
                        e.target.value = e.target.value.slice(
                          0,
                          e.target.maxLength
                        );
                      if (e.target.value.length !== 10) {
                        e.target.setCustomValidity("invalid Number");
                      } else if (e.target.value.length == 10) {
                        e.target.setCustomValidity("");

                        setmobile(e.target.value);
                      }
                    }}
                    onFocus={(e) =>
                      e.target.addEventListener(
                        "wheel",
                        function (e) {
                          e.preventDefault();
                        },
                        { passive: false }
                      )
                    }
                    maxlength={10}
                  />
                </div>
                {mobile?.length == 0 && mobileErr && (
                  <p className="err">Enter Mobile</p>
                )}
              </div>
            </Row>
            <Row>
              <div className="col-md-12 text-center mt-4 mb-4">
                <button
                  className={`submit-btn f2  ${btn ? "opacity-50" : ""}`}
                  onClick={() => submitHandler()}
                  disabled={btn}
                >
                  Save
                </button>
              </div>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receptionist;
